import React, { useEffect, useState } from 'react';
import { Button, Modal } from "react-bootstrap";
import { useSelector,useDispatch } from "react-redux";
import ARBProgressBar from '../Controls/ARBProgressBar.js';
import ConfirmationModal from './ConfirmationModal.js';
import APICom from '../../utils/helpers/APICom.js';
import { store ,persistor} from '../../store.js';
import { SetARBResponsePersistData } from '../../features/common/ARBSlice.js';

import ForceSchedulingComponent from '../Dispatch/ForceScheduling/ForceSchedulingComponent.js';
import RouteSuggestion from "../Dispatch/RouteSuggestion.js";
import PersistStorage from "../../utils/helpers/PersistStorage";
//import { faL } from '@fortawesome/free-solid-svg-icons';


var AutoPausingDialog = false;
var AutoPausingModalCloseTime = null;
const ARBResponseListener = (props) => {
    const [multiPageProgressBar, setmultiPageProgressBar] = useState(false);
    const dispatch = useDispatch();
    let ARBAutoResumeTimer = 60;
    let ARBTimer = 1;
    var interval_playing = null;
    const [forceData, setforceData] = useState('');
    const [stopViewGridData, setstopViewGridData] = useState('');
    const [showForceSchedulingComponent, setshowForceSchedulingComponent] = useState(false);
    const [P_MasterASCSCallerIDIframeURL, setP_MasterASCSCallerIDIframeURL] = useState("");
    const { AffiliateData, GlobalASCSData } = useSelector((store) => store.combinedata);
    const [showiFrame, setshowiFrame] = useState(false);
    const { loginData } = useSelector((store) => store.login);
    const [arbProgress, setarbProgress] = useState(0);
    const [showProgressBar, setshowProgressBar] = useState(false);
    const [showRouteSuggestionDialog, setRouteSuggestionDialog] = useState(false);
    const [confirmationModalObj, setConfirmationModalObj] = useState({
        show: false, title: 'Auto Routing',
        body: 'Are you Sure you want to Pause Auto-Routing?', btnCanceText: 'No',
        btnOkText: 'Yes'
    });
    const [selectedDescription, setSelectedDescription] = useState();
    const [selectedAffiliateID, setSelectedAffiliateID] = useState();
    const [rowReArrangeCheck, setRowReArrangeCheck] = useState(false);

    const [isMessageVisible, setMessageVisible] = useState({
        show: false, title: 'Auto Routing',
        body: ''
    });
    const [showMessageDialog, setshowMessageDialog] = useState
        (
            {
                "show": false,
                "Title": "",
                "Body": { __html: "", },
                "btn1_text": "",
                "btn2_text": "",
                "Showbtn1Button": false
            }
        );
        
        //const [AutoPausingDialog, setAutoPausingDialog] = useState(false);
        const handleOnTimerExpire = () => {
           
            handleYesButton();
        }
        const handleCloseButton = () => {
            
            handleNoButton();
        }
        const handleYesButton = () => {
            
            SaveRBSStatus("ResumedARBAutoRouting", 0, selectedDescription, selectedAffiliateID, 1);//1 form AutoResume Popup
            //setAutoPausingDialog(false);
            ARBTimer = -2;
            let currentTime = new Date(); // You can format this as needed
            AutoPausingDialog = false;
            AutoPausingModalCloseTime = currentTime;
            setARBModalObj((prevState) => ({ ...prevState, show: false }));
            if (interval_playing != undefined && interval_playing != null)
                clearInterval(interval_playing);
        }
        const handleNoButton = () => {
            SaveRBSStatus("ResumedARBAutoRouting", 2, selectedDescription, selectedAffiliateID, 1); //iPauseAutoRouting=2: When User click on No button, 1 form AutoResume Popup
            //setAutoPausingDialog(false);
            let currentTime = new Date(); // You can format this as needed
            ARBTimer = -1;
            AutoPausingDialog = false;
            AutoPausingModalCloseTime = currentTime;
            setARBModalObj((prevState) => ({ ...prevState, show: false }));
            if (interval_playing != undefined && interval_playing != null)
                clearInterval(interval_playing);
        }
    
    const [ARBModalObj, setARBModalObj] = useState({
        show: false, title: 'Auto Routing',
        body: 'Are you Sure you want to Pause Auto-Routing?', btnCanceText: 'No',
        btnOkText: 'Yes',
        ShowTimer: false,
        timerDuration: 60
    });
    //const [AutoPausingDialog, setAutoPauseDialog]= useState(false);
    
    const handleIframeLoad = () => {
        const iframe = document.getElementById('WMRMSCommonComifra');
        iframe.contentWindow.postMessage(loginData.iUserID, '*');
    };

function StartResumeNotificationTimer(affiliate_name, description, affiliate_id) {
    //setAutoPausingDialog(true);
    setARBModalObj((prevState) => ({
        ...prevState,
        show: true,
        title: affiliate_name + ` Resume Auto Routing`,
        body: `Do you want to Resume Auto-Routing for this date: ${description} ?`,
        btnCanceText: 'No',
        btnOkText: 'Yes',
        ShowTimer: true,
        timerDuration: 60
        
    }));
    AutoPausingDialog = true;
    AutoPausingModalCloseTime = null;
    /*
    interval_playing = setInterval(function()
    {
        //by parsing integer, I avoid all extra string processing
        let seconds = parseInt(ARBAutoResumeTimer, 10);
        --seconds;
        seconds = (seconds < 10) ? '0' + seconds : seconds;
        console.log(seconds);
        setARBModalObj((prevState) => ({
                        ...prevState,
                        title: affiliate_name + ` Resume Auto Routing | ${seconds}s`,
                    }));

        ARBAutoResumeTimer = seconds;
        if (seconds <= 0) {
            debugger;
            clearInterval(interval_playing);
            AutoPausingDialog= false;
            setARBModalObj((prevState) => ({ ...prevState, show: false }));
            SaveRBSStatus("ResumedARBAutoRouting", 0, description, affiliate_id, 1);
            console.log("Timer is zero");
        }
    }, 1000);
    */
}

useEffect(() => {
    console.log(props.handlePageProgressBar)
    if(props.handlePageProgressBar === null || props.handlePageProgressBar === undefined){
        setmultiPageProgressBar(false)
    }
    else{
        setmultiPageProgressBar(true)
    }
}, [props.handlePageProgressBar]);

function ResumeTimerFunction() {
    
}
useEffect(() => {
        if (GlobalASCSData !== null && GlobalASCSData !== undefined && GlobalASCSData.length > 0) {
            const jsonArray = GlobalASCSData;
            const URL = jsonArray.find(item => item.SubTitle === "AsteriskServerToClientCommAPI_URL");
            setP_MasterASCSCallerIDIframeURL(URL.value.replace('/api', ''));
        }
        else
            setP_MasterASCSCallerIDIframeURL('google.com');
        setupEventListeners();
    }, []);

    const handleIframeClose = () => {
        setshowiFrame(false);
    };

    const handleCloseClusteringDialog = () => {
        setshowMessageDialog
            (
                {
                    "show": false,
                    "Title": "",
                    "Body": { __html: "", },
                    "btn1_text": "",
                    "btn2_text": "",
                    "Showbtn1Button": false
                }
            );
    };

    const displayMessage = (text) => {
        setMessageVisible((prevState) => ({ ...prevState, show: true, body: text}));
        setTimeout(() => {
            setMessageVisible((prevState) => ({ ...prevState, show: false, body: ""}));
        }, 2000); 
    };

    const handleForceDispatch = () => {
        var storedDataJSON = sessionStorage.getItem('RecordIDs');
        var storedData = JSON.parse(storedDataJSON);

        NewRouteForcefullly(storedData.vServiceIDs, storedData.vScheduleIDs, storedData.pickupDateTime, storedData.affID, "0", storedData.manifestNumber, false, storedData.callBackURL, storedData.SelectedRecordsForARB, String(storedData.SelectedRouteSettingID));
        // setshowMessageDialog(false);
        // handleCloseClusteringDialog();
    };

    const setupEventListeners = () => {
        try {
            var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
            var eventer = window[eventMethod];
            var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
            //window.addEventListener(messageEvent, ARBResponseListener_NewRequestHTML);
            //window.addEventListener(messageEvent, ARBResponseListener_RBSProcess);
            // window.addEventListener(messageEvent, ARBResponseListener_StandingRouteMaker);
            // window.addEventListener(messageEvent, ARBResponseListener_RouteMaker);
            window.addEventListener(messageEvent, ARBResponseListener_Identifer);
            

        }
        catch (ee) {
            console.log('ARBResponseListener Setup Error: ' + ee);
        }
    };

    const hideClusteringDialog = (bRefreshGrid) => {
        setarbProgress(100);
        if (bRefreshGrid)
            props.GridRefresh();
        setTimeout(() => {
            setshowProgressBar(false);
            props.setShowClusterDialog(false);
        }, 2000);

    }
    const hideRoutingDialog = (bRefreshGrid) => {
        setarbProgress(100);
        if (bRefreshGrid)
            props.GridRefresh();
        setTimeout(() => {
            setshowProgressBar(false);
            props.setManifestBuildDialog(false);
        }, 2000);

    }
    const NewRouteForcefullly = async (serIDs, schIDs, reqDate, affID, type, manifest, mandatoryGrouping, cbURL, arrObj) => {
        let Param = {
            "assigned_driver_id": 0,
            "assigned_vehicle_id": 0,
            "service_ids_str": serIDs,
            "schedule_ids_str": schIDs,
            "mini_cluster_type": type,
            "req_date_str": reqDate,
            "manifest_number": manifest,
            "affiliate_id": affID,
            "requested_page_name": "ClusteringActions",
            "mandatory_grouping": mandatoryGrouping,
            "user_id": loginData.iUserID,
            "app_id": 26,
            "selected_records_for_cb": JSON.stringify(arrObj),
            "call_back_url": cbURL
        }
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/MakeRoute", "post", { "Content-Type": "application/json" }, Param, null);
        let result = response.data;
        if (result.run_id > 0) {
            hideClusteringDialog(true);
            setshowMessageDialog
            (
                {
                    "show": true,
                    "Title": "Auto Assignment",
                    "Body": { __html: "Route is being created...", },
                    "btn1_text": "",
                    "btn2_text": "Ok",
                    "Showbtn1Button": false
                }
            );
        }
        else {
            if (result.Error) {
                setshowMessageDialog
                    (
                        {
                            "show": true,
                            "Title": "Auto Assignment",
                            "Body": { __html: "Error Occured!!!!", },
                            "btn1_text": "",
                            "btn2_text": "Ok",
                            "Showbtn1Button": false
                        }
                    );
            }
            else {
                setshowMessageDialog
                    (
                        {
                            "show": true,
                            "Title": "Auto Assignment",
                            "Body": { __html: "Something went wrong!!!!", },
                            "btn1_text": "",
                            "btn2_text": "Ok",
                            "Showbtn1Button": false
                        }
                    );
            }
        }
    }

    

    
    const ARBResponseListener_Identifer = (ManifestPayLoad) => {
        try {
            if(ManifestPayLoad?.data?.split('||')[1] == 'ARBResponseListener_StandingRouteMaker'){
                ARBResponseListener_StandingRouteMaker(ManifestPayLoad);
            }
            else if(ManifestPayLoad?.data?.split('||')[1] == 'ARBResponseListener_RouteSuggestionMaker'){
                ARBResponseListener_RouteSuggestionMaker(ManifestPayLoad);
            }
            else if(ManifestPayLoad?.data?.split('||')[1] == 'ARBResponseListener_RouteMaker'){
                ARBResponseListener_RouteMaker(ManifestPayLoad);
            }
            else if(ManifestPayLoad?.data?.split('||')[1] == 'ARBResponseListener_RBSProcess'){
                ARBResponseListener_RBSProcess(ManifestPayLoad);
            }
            else if(ManifestPayLoad?.data?.split('||')[1] == 'ARBResponseListener_NewRequestHTML' || ManifestPayLoad?.data?.split('||')[1] == 'ARBResponseListener_ClusteringActions'
            || ManifestPayLoad?.data?.split('||')[1] == 'ARBResponseListener_UnClusteringAction'){
                ARBResponseListener_NewRequestHTML(ManifestPayLoad);
            }
            else if(ManifestPayLoad?.data?.split('||')[1] == 'ARBResponseListener_MTSMResponse')
            {
                console.log(ManifestPayLoad);
                ARBResponseListener_MTSMResponse(ManifestPayLoad);
            }
        }
        catch{}
    }
    var lastActivityTimeARBResumedNotification = null;
    function TimerFunction()
    {
        setTimeout(function () {
            if (ARBTimer <= 0) {
                handleCloseButton();
                return;
            }
            ARBTimer--;
            TimerFunction();
            setARBModalObj((prevState) => ({
                            ...prevState,
                         title: ` Resume Auto Routing in | ${ARBTimer}s`,
                        }));
                 }, 1000);
    }

    const ARBResponseListener_MTSMResponse = (ManifestPayLoad) =>{
        try{
            let _resp = '';
            if (ManifestPayLoad !== undefined && ManifestPayLoad !== null && ManifestPayLoad.data !== undefined && ManifestPayLoad.data !== null) {
                _resp = String(ManifestPayLoad.data);
                if(_resp.indexOf("WMRMSUserMessage=") > -1)
                {
                    let arrtparams = ManifestPayLoad.data.split("||"); //{“ConfirmationNo”: “001232832”, “TripID”: “231290”, “SchDateTime”: “”, “IsScheduled”: “false”, “Message”: “No Space Available”}
                    let args = arrtparams[0].replace((new RegExp("WMRMSUserMessage=", 'g')), "");
                    if (args != "") {
                        try{
                            _resp = JSON.parse(args);
                            let oldDataArr = PersistStorage.retrieve('confirmationsData', false);
                            if(oldDataArr && oldDataArr.length > 0)
                            {
                                for(let l = 0; l < oldDataArr.length; l ++)
                                    {
                                        if(String(oldDataArr[l].Confirmation) === String(_resp.message.ConfirmationNo))
                                        {
                                            if(String(_resp.message.IsScheduled)==="true"){
                                                oldDataArr[l].time = _resp.message.SchDateTime;
                                                oldDataArr[l].dropTime = _resp.message.SchDropTime;
                                                oldDataArr[l].msg = _resp.message.Message;
                                                oldDataArr[l].TripID = _resp.message.TripID;
                                            }
                                            else{
                                                oldDataArr[l].msg = _resp.message.Message;
                                                oldDataArr[l].time = "N/A";
                                                oldDataArr[l].dropTime = "N/A";
                                                oldDataArr[l].TripID = _resp.message.TripID;
                                            }
                                            // oldDataArr[l] = {ID: _resp.ConfirmationNo, time: null, name:"", creationTime: new Date(), msg:_resp.Message};
                                        }
                                    }
                                    
                                    PersistStorage.save('confirmationsData', oldDataArr, 999, false);
                            }
                            
                        }
                        catch(ex){console.log(ex);}
                    }
                    
                }
                
            }
        }
        catch (ex) {
            console.log("ARBResponseListener_MTSMResponse Error:");
            console.log(ex);
        }
    };

    const ARBResponseListener_RBSProcess = (ManifestPayLoad) => {
        try {
            let _resp = '';
            if (ManifestPayLoad !== undefined && ManifestPayLoad !== null && ManifestPayLoad.data !== undefined && ManifestPayLoad.data !== null) {
                _resp = String(ManifestPayLoad.data);
                if (_resp.indexOf("WMRMSUserMessage=") > -1) {
                    try {
                        var arrtparams = ManifestPayLoad.data.split("||");
                        var args = arrtparams[0].replace((new RegExp("WMRMSUserMessage=", 'g')), "");
                        if (args != "") {
                            try {
                                _resp = JSON.parse(args);
                                var status = _resp.status?.toLowerCase();
                                var description = _resp.description;
                                var affiliate_id = _resp.affiliate_id;
                                var affiliate_name = _resp.affiliate_name;
                                var user_id = _resp.user_id;
                                let _message = "";

                                if (status == "autoroutingpaused") {
                                    try {
                                        _message = "Auto Route successfully Paused.";
                                        displayMessage(_message);
                                    } catch (e) {
                                        console.log(e);
                                    }
                                }

                                if (status == "autoroutingresumed") {
                                    try {
                                        _message = "Auto Route successfully Resumed.";
                                        displayMessage(_message);
                                    } catch (e) {
                                        console.log(e);
                                    }
                                }

                                if (status == "arbresumednotification") {
                                    let seconds_between_two_events = -1;
                                    try {
                                        if (AutoPausingModalCloseTime != undefined && AutoPausingModalCloseTime != null)
                                            seconds_between_two_events = Math.abs((new Date().getTime() - AutoPausingModalCloseTime.getTime()) / 1000);
                                    } catch (e) {
                                        seconds_between_two_events = -1;
                                    }
                                    let isBrowserTabVisible = (function () {
                                        var stateKey, eventKey, keys = {
                                            hidden: "visibilitychange",
                                            webkitHidden: "webkitvisibilitychange",
                                            mozHidden: "mozvisibilitychange",
                                            msHidden: "msvisibilitychange"
                                        };
                                        for (stateKey in keys) {
                                            if (stateKey in document) {
                                                eventKey = keys[stateKey];
                                                break;
                                            }
                                        }
                                        return function (c) {
                                            if (c) document.addEventListener(eventKey, c);
                                            return !document[stateKey];
                                        }
                                    })();

                                    if (loginData.iUserID == user_id && AutoPausingDialog == false && (seconds_between_two_events == -1 || seconds_between_two_events > 60) && isBrowserTabVisible()) {
                                        //startTimer(description, affiliate_id, affiliate_name);
                                        //if (ARBAutoResumeTimer >= 59) {
                                          
                                            setSelectedDescription(description);
                                            setSelectedAffiliateID(affiliate_id);
                                            StartResumeNotificationTimer(affiliate_name,description,affiliate_id);
                                            
                                            /*
                                            setARBModalObj((prevState) => ({
                                                ...prevState,
                                                show: true,
                                                title: ` Resume Auto Routing | ${ARBAutoResumeTimer}s`,
                                                body: `Do you want to Resume Auto-Routing for '${affiliate_name}' date: ${description} ?`,
                                                btnCanceText: 'No',
                                                btnOkText: 'Yes'
                                            }));
                                            
                                            ARBTimer = ARBAutoResumeTimer;
                                            
                                            TimerFunction();

                                            */
                                            // _intervalPlaying = setTimeout(function () {
                                            //     if (ARBAutoResumeTimer <= 0) {
                                            //         ARBAutoResumeTimer = 60;
                                            //         clearInterval(_intervalPlaying);
                                            //         AutoPausingDialog = false;
                                            //         setARBModalObj((prevState) => ({ ...prevState, show: false }));
                                            //         SaveRBSStatus("ResumedARBAutoRouting", 0, description, affiliate_id, 1);
                                            //         console.log("Timer is zero");
                                            //     } else {
                                            //         ARBAutoResumeTimer--;
                                            //         setARBModalObj((prevState) => ({
                                            //             ...prevState,
                                            //             title: affiliate_name + ` Resume Auto Routing | ${ARBAutoResumeTimer}s`,
                                            //         }));
                                            //     }
                                            // }, 1000);
                                        //}
                                    }
                                }
                            }
                            catch (ex) {
                                console.log("ARBResponseListener_RBSProcess Error:");
                                console.log(ex);
                            }
                        }
                    }
                    catch (ex) {
                        console.log("ARBResponseListener_RBSProcess Error:");
                        console.log(ex);
                    }
                }
            }
        }
        catch (ex) {
            console.log("ARBResponseListener_RBSProcess Error:");
            console.log(ex);
        }
    }

    let _timeoutPlaying;

function startTimer(description, affiliate_id, affiliate_name) {
    //let ARBAutoResumeTimer = 60;

    if (ARBAutoResumeTimer >= 59) {
        setSelectedDescription(description);
        setSelectedAffiliateID(affiliate_id);

        setARBModalObj((prevState) => ({
            ...prevState,
            show: true,
            title: affiliate_name + ` Resume Auto Routing | ${ARBAutoResumeTimer}s`,
            body: `Do you want to Resume Auto-Routing for this date: ${description} ?`,
            btnCanceText: 'No',
            btnOkText: 'Yes',
        }));

        function updateTimer(description, affiliate_id, affiliate_name) {
            if (ARBAutoResumeTimer <= 0) {
                ARBAutoResumeTimer = 60;
                setARBModalObj((prevState) => ({ ...prevState, show: false }));
                SaveRBSStatus("ResumedARBAutoRouting", 0, description, affiliate_id, 1);
                console.log("Timer is zero");
            } else {
                ARBAutoResumeTimer--;
                setARBModalObj((prevState) => ({
                    ...prevState,
                    title: affiliate_name + ` Resume Auto Routing | ${ARBAutoResumeTimer}s`,
                }));
                _timeoutPlaying = setTimeout(updateTimer(description, affiliate_id, affiliate_name), 1000);
            }
        }
        updateTimer();
    }
}

    const ARBResponseListener_NewRequestHTML = (ManifestPayLoad) => {
        try {
            let _resp = '';
            if (ManifestPayLoad !== undefined && ManifestPayLoad !== null && ManifestPayLoad.data !== undefined && ManifestPayLoad.data !== null) {
                _resp = String(ManifestPayLoad.data);
                if (_resp.indexOf("WMRMSUserMessage=") > -1) {
                    try {
                        var arrtparams = ManifestPayLoad.data.split("||");
                        var args = arrtparams[0].replace((new RegExp("WMRMSUserMessage=", 'g')), "");
                        if (args != "") {
                            try {
                                _resp = JSON.parse(args);
                                if (_resp.status.toUpperCase() === 'SAVEDCOUNT') {
                                    if (parseInt(_resp.message) !== NaN) {
                                        if (parseInt(_resp.message) < 0) {
                                            setshowProgressBar(false);
                                            setarbProgress(1);
                                        }
                                        else if (parseInt(_resp.message) >= 100) {
                                            setarbProgress(100);
                                            props.setAlert(false);
                                        }
                                        else {
                                            setshowProgressBar(true);
                                            setarbProgress(parseInt(_resp.message));
                                            props.setAlert(false);
                                        }
                                    }
                                }
                                else if (_resp.status.toUpperCase() === 'PASS') {
                                    hideClusteringDialog(true);
                                    hideRoutingDialog(true);
                                    if (_resp.caller.toUpperCase() === 'BATCHROUTING') {
                                        setarbProgress(100);
                                        props.GridRefresh();

                                        hideRoutingDialog(true);
                                        if (_resp._JSON !== undefined && _resp._JSON !== null && _resp._JSON !== '') {
                                            let _JSON = JSON.parse(_resp._JSON);
                                            if (_JSON.ViolationString != "") {
                                                setshowMessageDialog
                                                    (
                                                        {
                                                            "show": true,
                                                            "Title": "Trips Violation",
                                                            "Body": { __html: _resp.violation_string.replace(new RegExp('\r?\n', 'g'), '<br/>'), },
                                                            "btn1_text": "",
                                                            "btn2_text": "Ok",
                                                            "Showbtn1Button": false
                                                        }
                                                    );
                                            }
                                        }
                                    }
                                    else if (_resp.caller.toUpperCase() === 'SINGLEROUTING') {
                                        let dialog_title = "Routing Results";//"Trips Violation";
                                        setarbProgress(100);

                                        props.GridRefresh();

                                        //setarbProgress(parseInt(_resp.message));
                                        hideClusteringDialog(true);
                                        if (_resp._JSON !== undefined && _resp._JSON !== null && _resp._JSON !== '') {
                                            let _JSON = JSON.parse(_resp._JSON);
                                            if (_JSON.ViolationString != "" && _JSON.ShowConfMsgToForcefullyRouteTrips == true) {
                                                setshowMessageDialog
                                                    (
                                                        {
                                                            "show": true,
                                                            "Title": dialog_title,
                                                            "Body": { __html: _resp.violation_string.replace(/\r?\n/g, '<br />'), },
                                                            "btn1_text": "Force Assign",
                                                            "btn2_text": "Cancel",
                                                            "Showbtn1Button": true
                                                        }
                                                    );
                                            }
                                            else if (_JSON.ViolationString != "") {
                                                setshowMessageDialog
                                                    (
                                                        {
                                                            "show": true,
                                                            "Title": dialog_title,
                                                            "Body": { __html: _resp.violation_string.replace(new RegExp('\r?\n', 'g'), '<br />'), },
                                                            "btn1_text": "",
                                                            "btn2_text": "Ok",
                                                            "Showbtn1Button": false
                                                        }
                                                    );
                                            }
                                        }
                                        else if (_resp.violation_string !== '') {
                                            
                                            FetchStopViewData(_resp)

                                        }
                                    }
                                    else if (_resp.caller.toUpperCase() === 'UNROUTING') {
                                        props.StopViewGridLoad();
                                        hideRoutingDialog(true);
                                        props.GridRefresh();
                                    }

                                    else if (_resp.caller.toUpperCase() === 'ROUTESUGGESTIONS') {
                                        setarbProgress(100);
                                        props.setRouteSuggestionActionCreate(false)
                                        props.GridRefresh();
                                        hideRoutingDialog(true);
                                        setforceData(_resp);
                                        setRouteSuggestionDialog(true)
                                    }
                                }
                                else if (_resp.status.toUpperCase() === 'FAIL') {
                                    console.log(ManifestPayLoad);
                                    props.GridRefresh();
                                    hideClusteringDialog(false);
                                    props.setRouteSuggestionActionCreate(false)
                                    hideRoutingDialog(false);
                                    setshowMessageDialog
                                        (
                                            {
                                                "show": true,
                                                "Title": "Routing Actions",
                                                "Body": { __html: (_resp.message === "" ? "Action failed" : _resp.message) },
                                                "btn1_text": "",
                                                "btn2_text": "Ok",
                                                "Showbtn1Button": false
                                            }
                                        );
                                }
                            }
                            catch (koip) { }
                        }
                    }
                    catch (qawdfr) { }
                }
            }
        }
        catch (err) {
            console.log('ARBResponseListener Error: ' + err);
        }
    };


    const ARBResponseListener_RouteSuggestionMaker = (ManifestPayLoad) => {
        try {
            let _resp = '';
            if (ManifestPayLoad !== undefined && ManifestPayLoad !== null && ManifestPayLoad.data !== undefined && ManifestPayLoad.data !== null) {
                _resp = String(ManifestPayLoad.data);
                if (_resp.indexOf("WMRMSUserMessage=") > -1) {
                    try {
                        var arrtparams = ManifestPayLoad.data.split("||");
                        var args = arrtparams[0].replace((new RegExp("WMRMSUserMessage=", 'g')), "");
                        if (args != "") {
                            try {
                                _resp = JSON.parse(args);
                                if (_resp.status?.toUpperCase() === 'SAVEDCOUNT') {
                              
                                }
                                else if (_resp.status?.toUpperCase() === 'PASS') {
                                    setarbProgress(5);
                                    setshowProgressBar(true);
                                    var responseData = _resp.data;
                                    if (_resp.caller?.toUpperCase() === 'VALIDATEROUTE') {
                                        if(responseData && responseData.length > 0){
                                            dispatch(SetARBResponsePersistData({data: responseData, name:"ARBResponseForRouteSuggestionValidate"}));
                                        }

                                        else{
                                            setshowMessageDialog
                                        (
                                            {
                                                "show": true,
                                                "Title": "Routing Actions",
                                                "Body": { __html: (_resp.message === "" ? "No Violation Found" : _resp.message) },
                                                "btn1_text": "",
                                                "btn2_text": "Ok",
                                                "Showbtn1Button": false
                                            }
                                        );
                                        }
                                        setTimeout(function () {
                                            setarbProgress(100);
                                            setshowProgressBar(true);
                                        }, 1000);
                                        setTimeout(function () {
                                            setshowProgressBar(false);
                                        }, 2000);
                                    }
                                    else{
                                        if(responseData && responseData.length > 0){
                                            dispatch(SetARBResponsePersistData({data: responseData, name:"ARBResponseForRouteSuggestionAdjustTime"}));
                                        }
                                        setTimeout(function () {
                                            setarbProgress(100);
                                            setshowProgressBar(true);
                                        }, 1000);
                                        setTimeout(function () {
                                            setshowProgressBar(false);
                                        }, 2000);
                                    }
                                }
                            }catch(ex){
                                console.log(ex);
                            }
                        }
                    }catch(ex){
                        console.log(ex);
                    }
                }
            }

        }catch(ex){
            console.log(ex);
        }
        
    }
    const ARBResponseListener_StandingRouteMaker = (ManifestPayLoad) => {
        try {
            let _resp = '';
            if (ManifestPayLoad !== undefined && ManifestPayLoad !== null && ManifestPayLoad.data !== undefined && ManifestPayLoad.data !== null) {
                _resp = String(ManifestPayLoad.data);
                if (_resp.indexOf("WMRMSUserMessage=") > -1) {
                    try {
                        var arrtparams = ManifestPayLoad.data.split("||");
                        var args = arrtparams[0].replace((new RegExp("WMRMSUserMessage=", 'g')), "");
                        if (args != "") {
                            try {
                                _resp = JSON.parse(args);
                                if (_resp.status?.toUpperCase() === 'SAVEDCOUNT') {
                              
                                }
                                else if (_resp.status?.toUpperCase() === 'PASS') {
                                    setarbProgress(5);
                                    setshowProgressBar(true);
                                    var responseData = _resp.data;
                                    if (_resp.caller?.toUpperCase() === 'VALIDATEROUTE') {
                                        if(responseData && responseData.length > 0){
                                            dispatch(SetARBResponsePersistData({data: responseData, name:"ARBResponseForValidate"}));
                                        }
                                        setTimeout(function () {
                                            setarbProgress(100);
                                            setshowProgressBar(true);
                                        }, 1000);
                                        setTimeout(function () {
                                            setshowProgressBar(false);
                                        }, 2000);
                                    }
                                    else{
                                        if(responseData && responseData.length > 0){
                                            dispatch(SetARBResponsePersistData({data: responseData, name:"ARBResponseForAdjustTime"}));
                                        }
                                    }
                                }
                            }catch(ex){
                                console.log(ex);
                            }
                        }
                    }catch(ex){
                        console.log(ex);
                    }
                }
            }

        }catch(ex){
            console.log(ex);
        }
        
    }

    const ARBResponseListener_RouteMaker = (ManifestPayLoad) => {
        try {
            let _resp = '';
            if (ManifestPayLoad !== undefined && ManifestPayLoad !== null && ManifestPayLoad.data !== undefined && ManifestPayLoad.data !== null) {
                _resp = String(ManifestPayLoad.data);
                if (_resp.indexOf("WMRMSUserMessage=") > -1) {
                    try {
                        var arrtparams = ManifestPayLoad.data.split("||");
                        var args = arrtparams[0].replace((new RegExp("WMRMSUserMessage=", 'g')), "");
                        if (args != "") {
                            try {
                                _resp = JSON.parse(args);
                                if (_resp.status?.toUpperCase() === 'SAVEDCOUNT') {
                                    // console.log(ManifestPayLoad);

                                }
                                else if (_resp.status?.toUpperCase() === 'PASS') {
                                    // console.log(ManifestPayLoad);
                                    setarbProgress(5);
                                    setshowProgressBar(true);
                                    var responseData = _resp.data;
                                    if (_resp.caller?.toUpperCase() === 'VALIDATEROUTE') {
                                        if(responseData.length > 0){
                                            dispatch(SetARBResponsePersistData({data: responseData, name:"ARBResponseForStopViewValidate"}));
                                        }
                                        setTimeout(function () {
                                            setarbProgress(100);
                                            setshowProgressBar(true);
                                        }, 1000);
                                        props.setAlert(false);
                                        setTimeout(function () {
                                            setshowProgressBar(false);
                                        }, 2000);
                                        
                                    }
                                    else{
                                        if(responseData.length > 0){
                                            dispatch(SetARBResponsePersistData({data: responseData, name:"ARBResponseForStopViewComputeEstimates"}));
                                        }
                                    }
                                }
                            }catch(ex){
                                console.log(ex);
                            }
                        }
                    }catch(ex){
                        console.log(ex);
                    }
                }
            }

        }catch(ex){
            console.log(ex);
        }
    }

    const SaveRBSStatus = async (ServiceStatus, iPauseAutoRouting, dtServiceDate, affilateId, iActionSource = 0) => { //1 = iActionSource Clicked from AutoResume Popup
        try {
            if (ServiceStatus == "StopFromMBPC") {//MBPC screen during Routing
                let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/StartStopProcess?iAffiliateID=" + affilateId + "&dtServiceDate=" + dtServiceDate + "&iPauseAutoRouting=" + iPauseAutoRouting + "&iActionSource=" + iActionSource + "&iUserID=" + loginData.iUserID, "post", { "Content-Type": "application/json" }, null, null);
                setARBModalObj((prevState) => ({ ...prevState, show: false }));
            }
            else if (ServiceStatus == "StopFromCallTaker" || ServiceStatus == "ResumedARBAutoRouting") {
                let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/StartStopProcess?iAffiliateID=" + affilateId + "&dtServiceDate=" + dtServiceDate + "&iPauseAutoRouting=" + iPauseAutoRouting + "&iActionSource=" + iActionSource + "&iUserID=" + loginData.iUserID, "post", { "Content-Type": "application/json" }, null, null);
                setARBModalObj((prevState) => ({ ...prevState, show: false }));
            } else {
                setConfirmationModalObj((prevState) => ({ ...prevState, show: true, title: 'Auto Routing', body: "Are you Sure you want to " + ServiceStatus + " Auto-Routing?", btnCanceText: 'No', btnOkText: 'Yes' }));

                var myData = "api/Routing/StartStopProcess?iAffiliateID=" + affilateId + "&dtServiceDate=" + dtServiceDate + "&iPauseAutoRouting=" + iPauseAutoRouting + "&iActionSource=" + iActionSource + "&iUserID=" + loginData.iUserID;
                sessionStorage.setItem('ARBProcessStatus', myData);

            }
        } catch (ex) {
            console.log(ex);
        }
    }

    const handleConfirmationModalCancel = () => {
        setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
        //UnMountRBSComponent();
    }

    const handleConfirmationModalClose = () => {
        setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
    }
    
    const handleConfirmationModalOk = () => {
        var storedDataJSON = sessionStorage.getItem('ARBProcessStatus');
        let response = APICom.fetchData("GenericManifestDotNetCoreURL", storedDataJSON, "post", { "Content-Type": "application/json" }, null, null);
        setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
    }

    const handleCloseRouting = () => {
        setMessageVisible((prevState) => ({ ...prevState, show: false, body: ""}));
    }

    const FetchStopViewData = async (_resp) => {
        const forceSelectedDate = PersistStorage.retrieve("forceSelectedDate", false);
        const forceManifestId = PersistStorage.retrieve("forceManifestId", false);
        const routeId = forceManifestId.substring(8);
        let params = {
          "iRunID": String(_resp.run_id),
          "RouteID": routeId,
          "selectedDate": forceSelectedDate
        }
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/StopsOnRouteSuggestion", "post", { "Content-Type": "application/json" }, params, null);
        if (response.data != null && response.data.StopView.length > 0){

            setforceData(_resp);
            setstopViewGridData(response.data.StopView)
            setshowForceSchedulingComponent(true);

        }

        else{

            setshowMessageDialog
            (
                {
                    "show": true,
                    "Title": "Routing Results",
                    "Body": { __html: _resp.violation_string.replace(new RegExp('\r?\n', 'g'), '<br />'), },
                    "btn1_text": "",
                    "btn2_text": "Ok",
                    "Showbtn1Button": false
                }
            );

        }
      }


    return (
        <div>
            <div style={{ display: 'none' }}>
                <iframe
                    src={P_MasterASCSCallerIDIframeURL + '/WMRMS/WMRMSCommonCom'}
                    id='WMRMSCommonComifra'
                    className="WMRMSCommonComifra"
                    onLoad={handleIframeLoad}
                    style={{
                        overflow: 'auto',
                        position: 'fixed',
                        top: '145px',
                        left: '50px',
                        height: '600px',
                        width: '80%',
                        zIndex: '7777',
                        border: '1px solid black'
                    }}
                />
                <Button onClick={handleIframeClose} variant="dark" style={{
                    overflow: 'auto',
                    position: 'fixed',
                    top: '745px',
                    left: '50px',
                    width: '10%',
                    zIndex: '7777'
                }}>Close</Button>
            </div>
            {showProgressBar && multiPageProgressBar ? <ARBProgressBar value={arbProgress}/> : ''}
            <Modal show={showMessageDialog.show ? 1 : 0} centered onHide={handleCloseClusteringDialog}
                aria-labelledby="contained-modal-title-vcenter">
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {showMessageDialog.Title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="grid-example" style={{ maxHeight: '400px', overflowY: 'auto' }}>

                    <div dangerouslySetInnerHTML={showMessageDialog.Body} />

                </Modal.Body>
                <Modal.Footer>
                    {showMessageDialog.Showbtn1Button ? <Button variant="dark" onClick={handleForceDispatch}>{showMessageDialog.btn1_text}</Button> : ""}
                    <Button variant="dark" onClick={handleCloseClusteringDialog}>{showMessageDialog.btn2_text}</Button>
                </Modal.Footer>
            </Modal>

            <ConfirmationModal show={confirmationModalObj.show} Title={confirmationModalObj.title} Body={confirmationModalObj.body}
                onOk={handleConfirmationModalOk} onCancel={handleConfirmationModalCancel} onClose={handleConfirmationModalClose} btnCanceText={confirmationModalObj.btnCanceText}
                btnOkText={confirmationModalObj.btnOkText} ShowCancelButton="true" 
                ShowTimer={confirmationModalObj.ShowTimer} timerDuration ={confirmationModalObj.timerDuration}
                onTimerExpire={confirmationModalObj.onTimerExpire}/>

            <ConfirmationModal centered  // Add the centered prop
                aria-labelledby="contained-modal-title-vcenter" show={ARBModalObj.show} Title={ARBModalObj.title} Body={ARBModalObj.body}
                onOk={handleYesButton} onCancel={handleNoButton} onClose={handleCloseButton} btnCanceText={ARBModalObj.btnCanceText}
                btnOkText={ARBModalObj.btnOkText} ShowCancelButton="true" ShowTimer={ARBModalObj.ShowTimer} timerDuration ={ARBModalObj.timerDuration}
                handleOnTimerExpire={handleOnTimerExpire} />

                <Modal show={isMessageVisible.show ? 1 : 0} centered onHide={handleCloseRouting}
                aria-labelledby="contained-modal-title-vcenter">
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Routing
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="grid-example">
                {isMessageVisible.body}
                </Modal.Body>
                <Modal.Footer>
                  
                </Modal.Footer>
            </Modal>
            {showForceSchedulingComponent ? <ForceSchedulingComponent  showForceSchedulingComponent={showForceSchedulingComponent} 
            setshowForceSchedulingComponent= {setshowForceSchedulingComponent} forceData= {forceData} stopViewGridData= {stopViewGridData}/> : "" }
            
            {showRouteSuggestionDialog ? 
                <RouteSuggestion 
                    setRouteSuggestionDialog={setRouteSuggestionDialog} showRouteSuggestionDialog = {showRouteSuggestionDialog} forceData={forceData} 
                    reArrangedRowsFlag={rowReArrangeCheck} setReArrangeFlag={setRowReArrangeCheck}
                /> 
            : "" }
        </div>
    );
};

export default ARBResponseListener;
